import React from 'react';
import { Box, Skeleton } from '@mui/material';

/**
 * Skeleton for profile/participant detail page (avatar + info blocks).
 */
export function ProfileDetailSkeleton() {
  return (
    <Box sx={{ width: '100%', maxWidth: 800, mx: 'auto', py: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 3, mb: 3 }}>
        <Skeleton variant="circular" width={100} height={100} />
        <Box sx={{ flex: 1 }}>
          <Skeleton variant="text" width="50%" height={32} sx={{ mb: 1 }} />
          <Skeleton variant="text" width="70%" height={24} sx={{ mb: 0.5 }} />
          <Skeleton variant="text" width="40%" height={20} />
        </Box>
      </Box>
      <Box sx={{ mt: 3 }}>
        <Skeleton variant="text" width="30%" height={24} sx={{ mb: 2 }} />
        <Skeleton variant="rectangular" width="100%" height={120} sx={{ borderRadius: 1, mb: 2 }} />
        <Skeleton variant="text" width="60%" height={20} sx={{ mb: 1 }} />
        <Skeleton variant="text" width="80%" height={20} />
      </Box>
    </Box>
  );
}
